import { validatable } from '../mixins/validation'
import { observable, computed } from 'mobx'
import { serializable, serialize, snapshotable } from '../data/serialization'
import { receiveErrors } from '../data/serverErrors'
import { Types } from '../data/Type'
import RynoEditor from '../ryno-editor/RynoEditor'
import { func } from 'validx'

/**
 * Txf config editor.
 */
@snapshotable
@validatable({ liveValidation: true })
export default class TxfConfigEditor {
  @observable
  @serializable
  integration_enabled_expr

  @observable
  @serializable
  show_questionnaire = false

  rules = {
    integration_enabled_expr: [
      func((ctx) => ctx.value.analyze(), 'There are formula errors.'),
    ],
  }

  constructor(legendEditor) {
    this.legendEditor = legendEditor
    this.integration_enabled_expr = new RynoEditor({
      getSymbolTable: () => this.symbolTable,
      getNeededType: () => Types.boolean,
    })
  }

  @computed
  get symbolTable() {
    return this.legendEditor.getSymbolTableFor(this)
  }

  hydrate(txfConfig) {
    if (!txfConfig) {
      this.integration_enabled_expr.setValue('')
      this.show_questionnaire = false
      return
    }

    this.integration_enabled_expr.setValue(
      txfConfig.integration_enabled_expr,
      true
    )
    this.show_questionnaire = txfConfig.show_questionnaire ?? false
  }

  toJSON() {
    return serialize(this)
  }

  receiveErrors(descriptor = {}) {
    const { inner = {} } = descriptor
    receiveErrors(this, inner)
  }
}
